import clsx from 'clsx'
import type { HTMLAttributes } from 'react'
import toast from 'react-hot-toast'
import styles from './WIP.module.css'

export interface WIPProps extends HTMLAttributes<HTMLDivElement> {}

export default function WIP({ children, className, ...props }: WIPProps) {
	return (
		<div className={clsx(styles.root, className)} {...props}>
			🚧 WIP {children}
		</div>
	)
}

export function toastWIP() {
	toast('🚧 WIP')
}
